<template>
    <b-tr>
        <b-td class="cell-table large-column align-middle">
            <v-tooltip
                v-if="emResult?.tier1?.status === 'error' && emResult?.tier1?.error_message"
                top
                max-width="300"
                content-class="custom-tooltip"
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind="attrs"
                        v-on="on"
                        class="em-status"
                    >
                        {{ emResult?.tier1?.status || '' }}
                    </div>
                </template>
                <span>{{ emResult?.tier1?.error_message }}</span>
            </v-tooltip>

            <span v-else class="em-status">
                {{ emResult?.tier1?.status || '' }}
            </span>
        </b-td>

        <b-td class="cell-table large-column align-middle">
            <v-tooltip
                v-if="emResult?.tier2?.status === 'error' && emResult?.tier2?.error_message"
                top
                max-width="300"
                content-class="custom-tooltip"
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind="attrs"
                        v-on="on"
                        class="em-status"
                    >
                        {{ emResult?.tier2?.status || '' }}
                    </div>
                </template>
                <span>{{ emResult?.tier2?.error_message }}</span>
            </v-tooltip>

            <span v-else class="em-status">
                {{ emResult?.tier2?.status || '' }}
            </span>
        </b-td>
    </b-tr>
</template>

<script>
import { getClassForCell } from "../utils"

export default {
    name: "RanchEMResultRow",
    props: {
        additionView: { type: Boolean, default: false },
        cropId: { type: Number },
        field: { type: String },
        emResult: {
            type: Object,
            default: () => ({}),
        },
        rowIndex: { type: Number },
        dataLength: { type: Number },
        year: { type: String },
    },
    data() {
        return {
            showDate: false,
            getClassForCell,
        }
    },
    methods: {
        filter(event) {
            event = event ? event : window.event
            let expect = event.target.value.toString() + event.key.toString()

            let validVal = this.handleValidateValue(expect, "number", 24)
            if (!validVal) event.preventDefault()
        },
    },
}
</script>

<style scoped>
.arva-alert {
    background-color: #f7c0be;
}

.cell-table {
    padding: 2px 6px;
}

.align-middle {
    vertical-align: middle !important;
}

.pre-gen {
    background-color: #fedb80;
}

.bg-white {
    color: white;
}

.cell-text {
    font-weight: 600;
    color: white;
}

.machine {
    background-color: #c0dce2;
}

.complete {
    background-color: #c7e3c1;
}

.copy-icon {
    cursor: pointer;
    color: #0f9aee;
}

.delete {
    color: #cc0101;
    cursor: pointer;
}

.input-check {
    cursor: pointer;
}

.select-check {
    margin-top: 14px;
    cursor: pointer;
}

.submit-icon {
    color: #c7e3c1;
}

.medium-column {
    width: 140px;
}

.large-column {
    width: 240px;
}

.marge-column {
    width: 180px;
}

.v-input {
    font-size: 18px;
}

.em-status {
    display: flex;
    align-items: center;
    min-height: 30px !important;
    padding: 0 8px;
    width: 100%;
    box-sizing: border-box;
}
</style>

<style>
.custom-tooltip {
    background-color: white !important;
    color: black !important;
    border-radius: 6px;
    padding: 8px 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
</style>